import React from 'react';

import Task from 'containers/Shared/Exams/Profile/Review/Tasks/Task';

import { useExamReviewStore } from 'store/exam/useExamReviewStore';

const Tasks = () => {
	// Use exam's store
	const tasks = useExamReviewStore(state => state.tasks);

	return (
		<div className="space-y-2">
			{tasks?.map((task) =>
				<Task key={task.id} task={task} />
			)}
		</div>
	);
};

export default Tasks;